import { Link, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/auth/useAuth'
import { PageHeader } from '@/components/ui'

interface Section {
  to: string
  label: string
  body: string
  adminOnly?: boolean
}

const SECTIONS: Section[] = [
  { to: '/admin/organisations', label: 'Partner organisations', body: 'Tier, subscription status and access.' },
  { to: '/admin/resources', label: 'Resource library', body: 'Publish, version and tier the library.' },
  { to: '/admin/reporting', label: 'Aggregate reporting', body: 'The cross-partner picture, for funders and the board.' },
  { to: '/admin/staff', label: 'Ki Tua o Matariki staff', body: 'Grant and revoke Ki Tua o Matariki access.', adminOnly: true },
  { to: '/admin/stock', label: 'Stock and fulfilment', body: 'Levels, reorder points and orders to pack.' },
  { to: '/admin/audit', label: 'Access and audit log', body: 'Who opened or exported what.' },
]

export function AdminHome() {
  const { isKtmAdmin } = useAuth()
  const location = useLocation()

  if (location.pathname !== '/admin') return <Outlet />

  const visible = SECTIONS.filter((s) => !s.adminOnly || isKtmAdmin)

  return (
    <>
      <PageHeader title="Administration">
        {isKtmAdmin
          ? 'Full administration. Changes to roles, tiers and pricing are recorded in the audit log.'
          : 'Operational administration. Role, tier and pricing changes need an admin.'}
      </PageHeader>
      <div className="grid gap-4 sm:grid-cols-2">
        {visible.map((section) => (
          <Link
            key={section.to}
            to={section.to}
            className="rounded-md border border-line bg-surface p-5 transition-colors hover:border-pounamu"
          >
            <h2 className="text-sm font-semibold text-ink">{section.label}</h2>
            <p className="mt-1 text-sm text-inksoft">{section.body}</p>
          </Link>
        ))}
      </div>
    </>
  )
}
